module.exports = __webpack_public_path__ + "media/images/weather-icons/fill/partly-cloudy-day-sleet-693b6fbf65578bbac4ccf345f0506816.svg";